<template>
  <div class="drag-image blue">
    {{ dragSelected ? selectedCount : '1' }}
  </div>
</template>

<script>
import useMultiSelect from '@/views/Context/use/useMultiSelect';
import { computed } from '@vue/composition-api';
export default {
  props: ['order', 'isSelectedPage'],
  setup(props) {
    const { startOrder, endOrder, selectedCount } = useMultiSelect();
    const dragSelected = computed(() => {
      if (props.isSelectedPage) {
        const min = Math.min(startOrder.value, endOrder.value);
        const max = Math.max(startOrder.value, endOrder.value);
        return props.isSelectedPage && props.order >= min && props.order <= max;
      } else {
        return false;
      }
    });
    return {
      dragSelected,
      selectedCount
    };
  }
};
</script>

<style></style>
